/** DO NOT EDIT THIS AUTO-GENERATED FILE! */
export const version = '6.0.8';
